//
// JS entry point
// ================================================================================

import { gallery } from './gallery.js';
import { menu } from './menu.js';
import { quotes } from './quotes.js';

function autorun(){
    gallery();
    menu();
    quotes();

    console.log('Scripts Loaded!');
};

if (document.addEventListener) document.addEventListener("DOMContentLoaded", autorun, false);
else if (document.attachEvent) document.attachEvent("onreadystatechange", autorun);
else window.onload = autorun;
